import { render } from "./DropdownStatics.vue?vue&type=template&id=252145da&ts=true"
import script from "./DropdownStatics.vue?vue&type=script&lang=ts"
export * from "./DropdownStatics.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__